function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useSelector } from 'react-redux';
import { convertFromTimeString } from 'helpers/datetime';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import ReadingValue from './components/ReadingValue';
import useRows from './useRows';
import styles from './Table.pcss';
const GestationalTable = ({ readings, reportsDates, conversion })=>{
    const gestationalReportSettings = useSelector(selectors.gestationalReportSettingsSelector);
    const dataRows = useRows(gestationalReportSettings, reportsDates, readings);
    const getTime = (index)=>convertFromTimeString(gestationalReportSettings[index].value);
    return /*#__PURE__*/ _jsxs("table", {
        className: styles.table,
        border: "1",
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("th", {
                            className: cn(styles['table__heading-col'], styles['table__heading-col--left']),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.labels.date))
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: styles['table__heading-col'],
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals.night_am))
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        getTime(0),
                                        " - ",
                                        getTime(1)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: styles['table__heading-col'],
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals.breakfast))
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        getTime(1),
                                        " - ",
                                        getTime(2)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: styles['table__heading-col'],
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals.lunch))
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        getTime(2),
                                        " - ",
                                        getTime(3)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: styles['table__heading-col'],
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals.dinner))
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        getTime(3),
                                        " - ",
                                        getTime(4)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("th", {
                            className: styles['table__heading-col'],
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals.night_pm))
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        getTime(4),
                                        " - ",
                                        getTime(0)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: dataRows.map((row)=>/*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                className: styles['table__heading-body-col'],
                                children: row.id
                            }),
                            row.values.map((value, index)=>// eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ _jsx("td", {
                                    className: styles.table__col,
                                    children: value.map((reading)=>/*#__PURE__*/ _jsx(ReadingValue, {
                                            reading: reading,
                                            conversion: conversion
                                        }, reading.readingId))
                                }, `col_${index}`))
                        ]
                    }, row.id))
            })
        ]
    });
};
GestationalTable.propTypes = {
    readings: PropTypes.array,
    reportsDates: PropTypes.object,
    conversion: PropTypes.object.isRequired
};
export default withStyles(styles)(injectIntl(GestationalTable));
